import React, { Component } from 'react';
import {
  ActivityIndicator,
  Alert,
  Dimensions,
  Image,
  Platform,
  StyleSheet,
  Text,
  TextInput,
  TouchableOpacity,
  View,
} from 'react-native';
import { connect } from 'react-redux';
import _ from 'lodash';

import { KeyboardAwareScrollView } from '../modules';
import Utils from '../utils/Utils';
import APIClient from '../utils/APIClient';
import AlertUtils from '../utils/AlertUtils';

const contentWidth = Math.min(Dimensions.get('window').width - 40, 300);

class PrepayScreen extends Component {

  static navigationOptions = ({navigation}) => {
    const {params} = navigation.state;
    return {
      headerBackTitle: null,
    };
  };

  constructor (props) {
    super(props);

    this.state = {
      seller: '',
      quantity: '10',
      bonus: '0',
    };
  }

  componentDidMount () {
  }

  componentWillUnmount () {
  }

  _updateInputValue (name, value) {
    this.setState({
      [name]: value,
    });
  }

  _focusTextInput (name) {
    const textInput = this.refs[name];
    if (textInput) {
      textInput.focus();
    }
  }

  _submit = () => {
    const {submitting} = this.state;
    if (submitting) {
      return;
    }

    const {seller, quantity, bonus} = this.state;
    let errorMessage, inputRefName;
    if (_.isEmpty(seller)) {
      errorMessage = 'Vui lòng điền id hoặc địa chỉ email của người bán';
      inputRefName = 'sellerIdTextInput';
    } else if (_.isEmpty(quantity)) {
      errorMessage = 'Vui lòng điền số lượng đặt mua';
      inputRefName = 'quantityTextInput';
    } else if (_.isEmpty(bonus)) {
      errorMessage = 'Vui lòng điền số lượng thưởng thêm';
      inputRefName = 'bonusTextInput';
    }

    if (errorMessage) {
      if (Platform.OS === 'web') {
        alert(errorMessage);
      } else {
        Alert.alert(
          global.__APP_NAME__,
          errorMessage,
          [
            {text: 'OK', onPress: () => this._focusTextInput(inputRefName)},
          ],
        );
      }
      return;
    }

    this._doSubmit();
  };

  _doSubmit = async () => {
    this.setState({
      submitting: true,
    });

    const {seller, quantity, bonus} = this.state;
    const path = `/admin/seller/${seller}/prepay`;
    const data = {
      quantity,
      bonus,
    };
    const {response, error} = await APIClient.POST(path, data);
    this._handleNetworkResponse(response, error);
  };

  _handleNetworkResponse (response, error) {
    if (response) {
      console.log(response);
    }
    if (error) {
      console.error(error);
    }

    this.setState({
      submitting: false,
    });

    if (response && response.response) {
      this.setState({
        items: response.response,
      });
    } else {
      const message
        = Utils.parseErrorMessage(response, error,
        'Sinh mã thất bại, vui lòng thử lại sau');
      AlertUtils.alert({message});
    }
  }

  render () {
    const {seller, quantity, bonus, items, submitting} = this.state;
    return (
      <KeyboardAwareScrollView
        automaticallyAdjustContentInsets={false}
        keyboardDismissMode={Platform.OS === 'ios' ? 'on-drag' : 'none'}
        keyboardShouldPersistTaps='always'
        containerContentStyle={styles.contentContainer}
        style={styles.container}>

        <Text
          style={[
            styles.inputTitleText, {
              marginTop: 24,
            }]}>
          ID hoặc email người bán
        </Text>
        <View
          style={styles.input}>
          <TextInput
            ref='sellerTextInput'
            value={seller}
            placeholder='ID hoặc email người bán'
            placeholderTextColor='#51585ebf'
            underlineColorAndroid='transparent'
            clearButtonMode='while-editing'
            returnKeyType='next'
            style={styles.textInput}
            onChangeText={(text) => this._updateInputValue('seller', text)}
            onSubmitEditing={() => this._focusTextInput('quantityTextInput')}/>
        </View>

        <Text
          style={styles.inputTitleText}>
          Số lượng
        </Text>
        <View
          style={styles.input}>
          <TextInput
            ref='quantityTextInput'
            value={quantity}
            placeholder='Số lượng'
            placeholderTextColor='#51585ebf'
            underlineColorAndroid='transparent'
            clearButtonMode='while-editing'
            keyboardType='numeric'
            autoCapitalize='none'
            returnKeyType='next'
            style={styles.textInput}
            onChangeText={(text) => this._updateInputValue('quantity', text)}
            onSubmitEditing={() => this._focusTextInput('bonusTextInput')}/>
        </View>

        <Text
          style={styles.inputTitleText}>
          Số lượng thưởng thêm
        </Text>
        <View
          style={styles.input}>
          <TextInput
            ref='bonusTextInput'
            value={bonus}
            placeholder='Số lượng'
            placeholderTextColor='#51585ebf'
            underlineColorAndroid='transparent'
            clearButtonMode='while-editing'
            keyboardType='numeric'
            autoCapitalize='none'
            returnKeyType='next'
            style={styles.textInput}
            onChangeText={(text) => this._updateInputValue('bonus', text)}
            onSubmitEditing={this._submit}/>
        </View>

        {!_.isEmpty(items) && <View
          style={styles.activateCodeContainer}>
          <Text
            style={styles.activateCodeContainerTitleText}>
            Danh sách mã trả trước
          </Text>
          {items.map((item, index) => {
            return (
              <Text
                key={index}
                style={styles.activateCodeText}>
                {item + '\n'}
              </Text>
            );
          })}
        </View>}

        <TouchableOpacity
          activeOpacity={0.75}
          onPress={this._submit}
          style={styles.submit}>
          <Image
            source={require('../img/btn.png')}
            style={styles.submitImage}/>
          <Text
            style={styles.submitText}>
            SINH MÃ
          </Text>
          {submitting && <View
            style={styles.submitting}>
            <ActivityIndicator
              animating
              color='#ffffff'
              style={styles.submittingIndicator}/>
          </View>}
        </TouchableOpacity>

      </KeyboardAwareScrollView>
    );
  }
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: '#f6efdb',
  },
  content: {
    flex: 1,
  },
  contentContainer: {},

  inputTitleText: {
    width: contentWidth,
    marginTop: 16,
    alignSelf: 'center',
    color: '#000000',
    fontSize: 16,
    fontWeight: '300',
    backgroundColor: 'transparent',
  },
  input: {
    width: contentWidth,
    height: 44,
    marginTop: 5,
    alignSelf: 'center',
    justifyContent: 'center',
    borderRadius: 16,
    borderWidth: 1,
    borderColor: '#e2d7ba',
    backgroundColor: '#ffffff',
  },
  textInput: {
    marginLeft: 12,
    padding: 0,
    color: '#51585e',
    fontSize: 17,
    fontWeight: '300',
    backgroundColor: 'transparent',
    ...Platform.select({
      web: {
        outline: 'transparent',
      },
    }),
  },

  activateCodeContainer: {
    marginTop: 24,
    alignItems: 'center',
  },
  activateCodeContainerTitleText: {
    marginBottom: 8,
    color: '#000000',
    fontSize: 17,
    fontWeight: '500',
    backgroundColor: 'transparent',
  },
  activateCodeText: {
    color: '#606060',
    fontSize: 15,
    fontWeight: '300',
    backgroundColor: 'transparent',
  },

  submit: {
    width: contentWidth,
    height: 56,
    marginTop: 24,
    alignSelf: 'center',
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: 'transparent',
  },
  submitImage: {
    position: 'absolute',
    top: 0, left: 0,
    width: contentWidth,
    height: 56,
    resizeMode: 'stretch',
  },
  submitText: {
    color: '#ffffff',
    fontSize: 20,
    fontWeight: 'bold',
    backgroundColor: 'transparent',
    zIndex: 1,
  },
  submitting: {
    position: 'absolute',
    top: 0, bottom: 0, right: 12,
    justifyContent: 'center',
    alignItems: 'center',
  },
  submittingIndicator: {},
});

const mapStateToProps = (state) => {
  return {};
};

const mapDispatchToProps = (dispatch) => {
  return {};
};

export default connect(mapStateToProps, mapDispatchToProps)(PrepayScreen);



// WEBPACK FOOTER //
// ./src/order/PrepayScreen.js